/**
 * Formats a date string (YYYY-MM-DD) into DD/MM/YYYY format.
 * Returns empty string if input is invalid.
 *
 * @param dateStr - The ISO date string to format (e.g., "2026-04-09")
 * @returns A formatted date string (e.g., "09/04/2026")
 */
export function formatDateHelper(dateStr: string | undefined): string {
  if (!dateStr) return '';

  const [year, month, day] = dateStr.split('-');
  if (!year || !month || !day) return '';

  return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`;
}
